import React from "react";
import TabsFancyTitle from "../TabsFancyTitle";
import Link from "../../_shared/Link";
import s from "./HighLights.module.css";
import { Mobile, Desktop } from "../../_shared/Bp";
import FancyTitle from "../../_shared/FancyTitle";

function Tags({ list }) {
  return (
    <div className={s.tags}>
      {list.map((item) => (
        <div className={s.tag} key={item.id}>
          {item.name}
        </div>
      ))}
    </div>
  );
}

function Icons({ list }) {
  return (
    <div className={[s.icons, s["mb-2"]].join(" ")}>
      {list.map((item) => (
        <img key={item.id} src={item.src} />
      ))}
    </div>
  );
}

function TitleAndIcons({ title, icons, order }) {
  if (order === "icons-title") {
    return (
      <React.Fragment>
        {icons.length > 0 && <Icons list={icons} />}

        <h5 className={[s.title, s["mb-2"]].join(" ")}>{title}</h5>
      </React.Fragment>
    );
  }

  return (
    <React.Fragment>
      <h5 className={[s.title, s["mb-2"]].join(" ")}>{title}</h5>

      {icons.length > 0 && <Icons list={icons} />}
    </React.Fragment>
  );
}

function Card({
  image,
  tag,
  link,
  description,
  tags,
  icons,
  elements_order = "icons-title",
}) {
  return (
    <Link settings={link} className={s.card}>
      <img className={s.image} src={image} alt={link.label} />

      <TitleAndIcons title={link.label} icons={icons} order={elements_order} />

      {description && (
        <div className={[s.description, s["mt-2"]].join(" ")}>
          {description}
        </div>
      )}
      {tags.length > 0 && <Tags list={tags} />}
    </Link>
  );
}

function HighLights({ data }) {
  return (
    <div className={s.highlights}>
      <Desktop>
        <TabsFancyTitle title={data.title} />
      </Desktop>

      <Mobile>
        <FancyTitle title={data.title} />
      </Mobile>

      <div className={s.cards}>
        {data.cards.map((card) => (
          <Card key={card.id} {...card} />
        ))}
      </div>
    </div>
  );
}

export default HighLights;
